import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m22.889 10.038-2.639-4.61a3.7 3.7 0 0 0-1.837-1.57l-1.752-.731a.9.9 0 0 0-.18-.322l-1.57-1.57a.8.8 0 0 0-.284-.173h-.11a1 1 0 0 0-.164-.055H9.64a1 1 0 0 0-.173 0 .5.5 0 0 0-.102 0 .8.8 0 0 0-.283.173l-1.57 1.57a.9.9 0 0 0-.18.322l-1.752.699a3.7 3.7 0 0 0-1.838 1.57l-2.638 4.697a.785.785 0 0 0 .33 1.091l4.28 2.144v6.282a2.56 2.56 0 0 0 1.436 2.301 11.16 11.16 0 0 0 9.675 0 2.57 2.57 0 0 0 1.453-2.27v-6.281l4.28-2.144a.79.79 0 0 0 .4-.472.79.79 0 0 0-.07-.651M11.997 4.195l-.966-1.618h1.932zM9.484 3.056l1.335 2.23-.786.26L9.029 3.52zm5.026 0 .455.464-1.013 2.026-.785-.26zm3.77 8.458V10.43a.785.785 0 1 0-1.572 0v9.157a.98.98 0 0 1-.557.895 9.63 9.63 0 0 1-8.324 0 .98.98 0 0 1-.542-.895V10.43a.785.785 0 1 0-1.57 0v1.084l-2.836-1.413 2.23-3.927a2.1 2.1 0 0 1 1.053-.887l1.657-.668 1.123 2.238a.785.785 0 0 0 .95.393l2.105-.707 2.104.707a.785.785 0 0 0 .95-.393l1.123-2.238 1.65.668c.448.175.823.5 1.06.918l2.23 3.927z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.96 8.86a1.963 1.963 0 1 0 0 3.926 1.963 1.963 0 0 0 0-3.926m0 2.356a.393.393 0 1 1 0-.785.393.393 0 0 1 0 .785"
    }, null, -1)
  ]))]))
}
export default { render: render }